module.exports = __webpack_public_path__ + "src/img/zalando/img-single.2b719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-single.jpg
// module id = 267
// module chunks = 0